import { Injectable } from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {OtpDeliveryMethod} from '../login.model';
import {map} from 'rxjs/operators';
import {LoginService} from '../login.service';

@Injectable()
export class OtpInputService {
  private _selectedOtpDeliveryMethod$ = new BehaviorSubject<OtpDeliveryMethod>(undefined);
  readonly selectedOtpDeliveryMethod$ = this._selectedOtpDeliveryMethod$.asObservable();
  get selectedLevel2OtpGenerator(): OtpDeliveryMethod { return this._selectedOtpDeliveryMethod$.getValue(); }
  set selectedLevel2OtpGenerator(value: OtpDeliveryMethod) { this._selectedOtpDeliveryMethod$.next(value); }

  readonly showForm$ = this.selectedOtpDeliveryMethod$.pipe(map(value => [OtpDeliveryMethod.SMS, OtpDeliveryMethod.APP].includes(value)));

  readonly showRequireNewOtpButton$ = this.selectedOtpDeliveryMethod$.pipe(map(value => [OtpDeliveryMethod.EMAIL, OtpDeliveryMethod.SMS].includes(value)));
  readonly inputFormSpan$ = this._selectedOtpDeliveryMethod$.pipe(map(value => value === OtpDeliveryMethod.APP ? 24 : 12));

  readonly level2QrCode$ = this.loginService.level2QrCode$;

  constructor(
    private loginService: LoginService
  ) { }
}
